module.exports = __webpack_public_path__ + "img/decosummit-white.62daf762.svg";